import React from 'react';
import { Image } from 'antd';
import { ImageProps } from 'rc-image';

export const MenuItemImage: React.FC<ImageProps> = ({ src, preview = false, ...rest }) => {
  return <Image src={`/api/images/${src}`} preview={preview} {...rest} />;
};
